import { render } from "./ImgLogo2.vue?vue&type=template&id=7451f133"
import script from "./ImgLogo2.vue?vue&type=script&lang=js"
export * from "./ImgLogo2.vue?vue&type=script&lang=js"

import "./ImgLogo2.vue?vue&type=style&index=0&id=7451f133&lang=css"

import exportComponent from "C:\\Users\\Fernando\\Desktop\\curso Innovaccion Virtual\\FrontEnd\\Practica5 VUE\\pasteleria-vuex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__